import moment from 'moment'

import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setAlertNotes } from 'src/store/modules/reports'

import { ALERT_NOTES_REPORT, DATE_TIME_FORMAT_FOR_SERVER } from 'src/constants'
import { exportReport } from 'src/utils/Functions'

export const fetchAlertNotesReport =
  ({ params = {}, query = {} }) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: ALERT_NOTES_REPORT,
          params,
          query
        }
      })

      dispatch(setAlertNotes(items))

      return meta
    } catch (err) {
      catchError(err)

      return false
    }
  }

export const exportAlertNotesReport =
  (config = {}) =>
  async () => {
    await exportReport(
      config,
      `alert_notes_report_${moment().format(DATE_TIME_FORMAT_FOR_SERVER)}.xls`
    )
  }
